import { IconButton, Tooltip } from '@material-ui/core';
import { Menu, People, Settings } from '@material-ui/icons';
import React from 'react';

import { PageDialogLink } from '../../common/page-dialog-link';
import { JobEdit } from '../../containers/job-edit';
import { JobOutreachButton } from '../job-outreach-button';
import { JobSearches } from '../job-searches';

export const JobActions: React.FC<{
    id: string;
}> = ({ id }) => {
    const editUrl = `/job/${id}/edit`;
    const searchesUrl = `/job/${id}/searches`;

    return (
        <>
            <span>
                <span className="initial">
                    <IconButton size="small">
                        <Menu fontSize="small" />
                    </IconButton>
                </span>
                <span className="hovered">
                    <JobOutreachButton jobId={id} iconColor="primary" iconSize="small" />
                    <PageDialogLink Component={JobEdit} componentProps={{ id }} url={editUrl}>
                        <Tooltip title="View/Edit Job Settings">
                            <IconButton size="small">
                                <Settings fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </PageDialogLink>
                    <PageDialogLink Component={JobSearches} componentProps={{ id }} url={searchesUrl}>
                        <Tooltip title="Job Searches">
                            <IconButton size="small">
                                <People fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </PageDialogLink>
                </span>
            </span>
        </>
    );
};
